define('app-SearchResults/modules/resultsList/settings',[],function () {
    return {
        container: '.searchResults',
        searchUrlKey: 'app-Search-Tags',
        pixelThreshholdToLoadMoreResults: 850,
        chunkPositionKey: 'app-Search-ChunkPosition',
        scrollPositionKey: 'app-Search-ScrollPosition',
        pagePositionKey: 'app-Search-PagePosition',
        sortOrderKey: 'app-Search-SortBy'
    };
});
